<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

      <h1>Alunos pendentes</h1>
      <p style="text-align: justify;">Tela destinada a aprovação dos alunos que geram seu próprio cadastro. Todo cadastro realizado diretamente pelo aluno necessita de aprovação de um professor ou administrador para permitir o uso deste simulador.</p>

      <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>Alunos pendentes</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                
                                <div class="form-group d-flex align-items-center">
                                    <label for="turma" class="mt-1 mr-2" style="flex: 0 0 auto;">Selecione a turma:</label>
                                    &nbsp;&nbsp;&nbsp;
                                    <select class="form-control custom-select-sm custom-dropdown" v-model="turma_selecionada" style="width: 40%;">
                                        <option value="" selected>-- Selecione uma turma --</option>
                                        <option v-for="turma in turmas" :key="turma.id" :value="turma.id">{{ turma.descricao }}</option>
                                    </select>
                                </div>
                                <!-- Span explicativo -->
                                <div class="form-group">
                                    <span class="form-text text-muted">
                                        O(s) aluno(s) selecionado(s) será(ão) aprovado(s) e adicionado(s) na turma selecionada aqui. Caso nenhuma turma seja selecionada o aluno será apenas aprovado e conseguirá acessar o simulador porém sem vinculado de turma.
                                    </span>
                                </div>

                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">
                                                    <input type="checkbox" @change="toggleSelecaoTodos" :checked="todosSelecionados">
                                                </th>
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Nome</th>
                                                <th scope="col" style="background-color: lightgrey;">E-mail</th>
                                                <th scope="col" style="background-color: lightgrey;"><!-- Aprovar --></th>
                                                <th scope="col" style="background-color: lightgrey;"><!-- Deletar --></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="aluno in pendentes">
                                                <td style="text-align: center;">
                                                    <input type="checkbox" :checked="isAlunoSelecionado(aluno.id)" @change="toggleSelecaoAluno(aluno.id)">
                                                </td>
                                                <td style="text-align: right;">{{ aluno.id }}</td>
                                                <td style="text-align: left;">{{ aluno.name }}</td>
                                                <td style="text-align: left;">{{ aluno.email }}</td>
                                                <td style="text-align: center;">
                                                    <button @click="gravar(aluno.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Aprovar</label>
                                                    </button>
                                                </td>
                                                <td style="text-align: center;">
                                                    <button @click="excluirItem(aluno.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="pendentes.length == 0">Nenhum cadastro pendente de aprovação.</p>
                                    <p v-else>{{ pendentes.length }} registro(s) aguardando aprovação.</p>

                                    <button @click="aprovarSelecionados" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 200px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span> 
                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Aprovar selecionados</label>
                                    </button>

                                    <button @click="deletarSelecionados" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 200px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar selecionados</label>
                                    </button>

                            </div>
                        </div>
                    </div>
                </div>
    </div>
  </template>
  
<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            pendentes: {
                type: Object,
            },
        },
        
        mounted() {
            this.CarregarTurmas();
        },
        computed: {
            todosSelecionados() {
                return this.pendentes.length && this.pendentes.every(aluno => this.alunosSelecionados.includes(aluno.id));
            }
        },
        data() {
            return {
                BASE_URL: window.Laravel.baseUrl,
                alunosSelecionados: [],
                turma_selecionada: '',
                turmas: {},
            };
        },
        methods: {
            toggleSelecaoTodos() {
                if (this.todosSelecionados) {
                    this.alunosSelecionados = []; // Desmarcar todos
                } else {
                    this.alunosSelecionados = this.pendentes.map(aluno => aluno.id); // Marcar todos
                }
            },
            isAlunoSelecionado(id) {
                return this.alunosSelecionados.includes(id);
            },
            toggleSelecaoAluno(id) {
                const index = this.alunosSelecionados.indexOf(id);
                if (index > -1) {
                    this.alunosSelecionados.splice(index, 1); // Remove o ID se já estiver no array
                } else {
                    this.alunosSelecionados.push(id); // Adiciona o ID se não estiver no array
                }
            },
            deletarSelecionados() {
                if (this.alunosSelecionados.length === 0) {
                    alert('Nenhum usuário selecionado para deletar.');
                    return;
                }

                if (confirm('Tem certeza que deseja deletar os usuários selecionados?')) {
                    axios.post(this.BASE_URL + 'pendente/remover_multiple', { ids: this.alunosSelecionados })
                        .then(response => {
                            if (response.status === 200) {
                                alert('Usuários deletados com sucesso!');
                                window.location.reload();
                            } else {
                                alert('Erro ao deletar usuários.');
                            }
                        })
                        .catch(error => {
                            alert('Erro ao deletar usuários: ' + error);
                            console.error('Erro ao deletar usuários selecionados', {
                                status: error.response?.status,
                                url: error.config?.url,
                                method: error.config?.method,
                                response: error.response?.data,
                            });
                        });
                }
            },
            aprovarSelecionados() {

                if (this.alunosSelecionados.length === 0) {
                    alert('Nenhum aluno selecionado para aprovar.');
                    return;
                }

                if (confirm('Tem certeza que deseja aprovar os alunos selecionados?')) {
                    axios.post(this.BASE_URL + 'pendente/aprovar_multiple', { ids: this.alunosSelecionados, turma_selecionada: this.turma_selecionada })
                        .then(response => {
                            if (response.status === 200) {
                                alert('Alunos aprovados com sucesso!');
                                window.location.reload();
                            } else {
                                alert('Erro ao aprovar alunos.');
                            }
                        })
                        .catch(error => {
                            alert('Erro ao aprovar alunos: ' + error);
                            console.error('Erro ao aprovar alunos selecionados', {
                                status: error.response?.status,
                                url: error.config?.url,
                                method: error.config?.method,
                                response: error.response?.data,
                            });
                        });
                }

            },
            gravar(id) {
                const dados_gravar = {
                    id: id,
                    turma_selecionada: this.turma_selecionada,
                };

                axios.post(this.BASE_URL + 'pendente/aprovar/' + id, dados_gravar)
                    .then(response => {
                        if (response.status === 200) {
                            alert('Aluno aprovado com sucesso!');
                            window.location.reload();
                        } else {
                            alert('Erro ao gravar dados.');
                        }
                    })
                    .catch(error => {
                        alert('Erro ao gravar dados: ' + error);
                        console.error(error);
                    });
            },
            excluirItem(id) {
                if (confirm('Tem certeza que deseja deletar este usuário?')) {
                    const dados_remover = {
                        id: id,
                    };
                    axios.delete(this.BASE_URL + 'pendente/remover/' + id, dados_remover)
                        .then(response => {
                            if (response.status === 200) {
                                alert('Usuário deletado com sucesso!');
                                window.location.reload();
                            } else {
                                alert('Erro ao deletar usuario.');
                            }
                        })
                        .catch(error => {
                            alert('Erro ao deletar usuario: ' + error);
                            console.error(error);
                        });
                }
            },
            CarregarTurmas() {
                    axios.get(this.BASE_URL + 'turmas/buscar_turmas/')
                        .then(response => {
                            if (response.status === 200) {
                                this.turmas = response.data;
                            } else {
                                alert('Erro ao buscar turmas.');
                            }
                        })
                        .catch(error => {
                            alert('Erro ao deletar usuario: ' + error);
                            console.error(error);
                        });
            },
        },

    };
</script>

<style scoped>
/* Adicione estilos específicos para o componente About aqui se necessário */
h1{
    font-size: 26px;
}
</style>
  
